import { connect } from 'react-redux'

import {
  doMarkAsRead,
  doFetchTicketActions,
  doFetchTicketLinkedResources,
} from 'actions/tickets'

import {
  selectCurrentTicketUndecorated,
  selectIsCustomerEmailBlank,
} from 'selectors/tickets'
import { selectCurrentTicketChangesetsLoaded } from 'selectors/currentChangesets'

import { selectIsComposingMessage } from 'selectors/page'

import TicketInspector from './view'

const select = state => ({
  isCustomerEmailBlank: selectIsCustomerEmailBlank(state),
  isFooterOpen: selectIsComposingMessage(state),
  // perf: this is pants. But better than passing down thru Layout!!
  ticket: selectCurrentTicketUndecorated(state),
  changesetsLoaded: selectCurrentTicketChangesetsLoaded(state),
})

const perform = {
  doMarkAsRead,
  doFetchTicketActions,
  doFetchTicketLinkedResources,
}

export default connect(select, perform)(TicketInspector)
